import theme from "./theme";

const activeColors = {
  default: "#95CA3D",
  about: "#95CA3D",
  study: "#0EB4BD",
  live: "#F3B21B",
  investigation: "#42D3B8",
  cooperate: "#9878D3",
  international: "#F0592A"
};

const viewsColors = {
  root: activeColors.default,
  cooperate: activeColors.cooperate,
  education: activeColors.study,
  public: activeColors.default,
  index: activeColors.default,
  internal: activeColors.default,
  international: activeColors.international,
  live: activeColors.live,
  investigation: activeColors.investigation
};

/*
-- Atoms
*/

//AnimatedBackground
const animatedBackground = {
  backgroundColor: "#f6f7f8",
  gradientColor: ["#eeeeee", "#dddddd", "#eeeeee"]
};

//Button
const button = {
  //Global
  fontSize: theme.sizes.s,
  fontWeight: String(theme.weight.light),
  padding: "10px 20px",
  lineHeight: "1",
  //Primary
  primaryColor: theme.colors.black,
  primaryBackgroundColor: theme.colors.white,
  primaryBorderColor: theme.colors.blue,
  primaryHoverColor: theme.colors.white,
  primaryHoverBackgroundColor: theme.colors.blue,
  primaryFocus: "rgba(0,178,189,0.4)",
  primaryIconBackgroundColor: theme.colors.white,
  primaryIconColor: theme.colors.blue,
  //Dark
  darkColor: theme.colors.white,
  darkBackgroundColor: theme.colors.black,
  darkBorderColor: theme.colors.white,
  darkHoverColor: theme.colors.black,
  darkHoverBackgroundColor: theme.colors.white,
  darkFocus: "rgba(255,255,255,0.4)",
  darkIconBackgroundColor: theme.colors.black,
  darkIconColor: theme.colors.white,
  //Light
  lightColor: theme.colors.white,
  lightBackgroundColor: theme.colors.blue,
  lightBorderColor: theme.colors.white,
  lightHoverColor: theme.colors.blue,
  lightHoverBackgroundColor: theme.colors.white,
  lightFocus: "rgba(255,255,255,0.4)",
  lightIconBackgroundColor: theme.colors.blue,
  lightIconColor: theme.colors.white,
  //Default
  color: theme.colors.black,
  backgroundColor: theme.colors.white,
  borderColor: theme.colors.black,
  hoverColor: theme.colors.white,
  hoverBackgroundColor: theme.colors.black,
  focus: "rgba(0,0,0,0.4)",
  iconBackgroundColor: theme.colors.white,
  iconColor: theme.colors.black
};

//Icon
const icon = {
  color: theme.colors.black
};

//Input
const input = {
  fontSize: theme.sizes.s,
  color: theme.colors.black,
  height: theme.sizes.xl5,
  focus: "rgba(0, 0, 0, 0.4)"
};

//Line
const line = {
  width: 34,
  height: 5,
  color: theme.colors.white,
  marginTop: 0,
  marginTopMarkdown: 10,
  widthDifference: 8
};

//Link
const link = {
  color: theme.colors.grey,
  fontSize: theme.sizes.s,
  fontWeight: String(theme.weight.xbase)
};

//Text
const text = {
  fontSize: theme.typos.text,
  color: theme.colors.black,
  colorReverse: theme.colors.white,
  fontWeight: String(theme.weight.xbase)
};

//Triangle
const triangle = {
  color: theme.colors.black
};

//Title - Will be removed
const title = {
  fontSize: theme.typos.title,
  color: theme.colors.white,
  fontWeight: String(theme.weight.xbase),
  fontFamily: theme.type.base,
  lineHeight: 1.4
};

//ListItem
const ListItem = {
  lineColor: theme.colors.greyBorder,
  spacingBottom: theme.spacing.s,
  spacingLeft: theme.spacing.s
};

/*
-- Molecules
*/

//StudentCard
const studentCard = {
  borderColor: "#cccccb"
};

//AgendaFeatured
const agendaFeatured = {
  dateContainerTextColor: "rgb(77, 147, 255)",
  buttonBgColor: "rgb(77, 147, 255)",
  buttonTextColor: theme.colors.white,
  textColor: theme.colors.white,
  titleColor: theme.colors.white,
  dateColor: theme.colors.black,
  dateContainerBgColor: theme.colors.white,
  borderColor: theme.colors.white,
  textColorHover: theme.colors.white,
  animationBgColor: "rgb(77, 147, 255)"
};

//PlusButton
const plusButton = {
  backgroundColor: theme.colors.white
};

//Section
const section = {
  paddingTop: theme.spacing.xl4,
  mdPaddingTop: theme.spacing.xl5,
  paddingBottom: theme.spacing.xl4,
  backgroundColor: theme.colors.white
};

//Table
const table = {
  borderColor: "rgb(147, 149, 151)",
  borderLightColor: "rgba(147, 149, 151, 0.5)",
  optionColor: theme.colors.focus,
  minorColor: theme.colors.focus,
  linksTextDecorationColor: theme.colors.focus
};

//CandidatureCard
const candidatureCard = {
  buttonBackgroundColor: "#00AFBB",
  titleColor: theme.colors.black,
  cardBackgroundColor: theme.colors.white
};

const dropDown = {
  backgroundColor: theme.colors.white,
  minWidth: "210px"
};

const dropList = {
  color: theme.colors.greyAnchor,
  hoverBackgroundColor: theme.colors.greyAnchor
};

//here
const sectionHeader = {
  backgroundColor: theme.colors.black,
  textColor: theme.colors.white
};

const select = {
  textColor: theme.colors.white,
  borderColor: theme.colors.white,
  outlineColor: theme.colors.focus
};

const tabContent = {
  marginTop: theme.spacing.xs2,
  backgroundColor: "transparent"
};

const article = {
  backgroundColor: theme.colors.white
};

//Carousel
const carousel = {
  legendColor: theme.colors.black,
  dotsColor: theme.colors.grey
};

//CustomArrow
const customArrow = {
  customArrowColor: 'rgb(204, 204, 203)'
};

const listItem = {
  lineColor: theme.colors.greyBorder,
  spacingBottom: theme.spacing.s,
  spacingLeft: theme.spacing.s
};

//MobilePublicNavBar
const mobilePublicNavBar = {
  backgroundColor: theme.colors.white,
  linksColor: theme.colors.black,
  textColor: theme.colors.black,
  iconColor: theme.colors.black,
  boxShadow: "0 15px 10px -15px rgba(0, 0, 0, 0.2)"
};

//PublicNavBar
const publicNavbar = {
  borderColor: "#e6e6e6",
  linksColor: theme.colors.black,
  backgroundColor: theme.colors.white,
  iconColor: theme.colors.black,
  myUAColor: theme.colors.green
};

export default {
  ...theme,
  viewsColors,
  components: {
    //Atoms
    animatedBackground,
    button,
    icon,
    input,
    line,
    link,
    text,
    triangle,
    title,
    ListItem,
    customArrow,
    //Molecules
    studentCard,
    agendaFeatured,
    plusButton,
    section,
    table,
    candidatureCard,
    dropDown,
    dropList,
    carousel,
    listItem,
    publicNavbar,
    mobilePublicNavBar,
    //Organisms
    sectionHeader,
    select,
    tabContent,
    article,
  }
};
